import React, { useState } from "react";
import { ShareNetwork, WhatsappLogo, TelegramLogo, Link, X } from "@phosphor-icons/react";
import { toast } from "sonner";

/**
 * Global Share button — top-right on major screens.
 * Supports Native share, WhatsApp, Telegram, Copy Link.
 */
export default function ShareButton({ title = "Q Drives", text = "Q Drives — Premium Vehicle Acquisition", url, testid = "share-btn" }) {
  const [open, setOpen] = useState(false);
  const finalUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  const shareText = `${text}\n${finalUrl}`;

  const tryNative = async () => {
    if (typeof navigator !== "undefined" && navigator.share) {
      try { await navigator.share({ title, text, url: finalUrl }); return true; } catch (err) { /* user cancelled or share failed */ if (err?.name !== "AbortError") console.error("Native share failed:", err); }
    }
    return false;
  };

  const open_ = async () => {
    const used = await tryNative();
    if (!used) setOpen(true);
  };

  const onWhatsApp = () => window.open(`https://wa.me/?text=${encodeURIComponent(shareText)}`, "_blank");
  const onTelegram = () => window.open(`https://t.me/share/url?url=${encodeURIComponent(finalUrl)}&text=${encodeURIComponent(text)}`, "_blank");
  const onCopy = async () => {
    try { await navigator.clipboard.writeText(finalUrl); toast.success("Link copied"); } catch { toast.error("Copy failed"); }
    setOpen(false);
  };

  return (
    <>
      <button data-testid={testid} onClick={open_} className="qd-glass rounded-full p-2.5 hover:bg-white/[0.06] transition-colors">
        <ShareNetwork size={16} className="text-white/85" />
      </button>
      {open && (
        <div className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center" onClick={() => setOpen(false)} data-testid="share-sheet">
          <div className="absolute inset-0 bg-black/65" />
          <div className="relative qd-card w-full sm:max-w-sm m-4 p-1" onClick={(e) => e.stopPropagation()} style={{ borderColor: "rgba(255,30,30,0.25)" }}>
            <div className="flex items-center justify-between px-4 py-3 border-b border-[#1A1A1A]">
              <div className="qd-overline">Share</div>
              <button onClick={() => setOpen(false)} className="text-white/60 hover:text-white"><X size={16} /></button>
            </div>
            <div className="grid grid-cols-3 gap-px bg-[#1A1A1A]">
              <Action icon={WhatsappLogo} label="WhatsApp" onClick={onWhatsApp} testid="share-whatsapp" />
              <Action icon={TelegramLogo} label="Telegram" onClick={onTelegram} testid="share-telegram" />
              <Action icon={Link} label="Copy Link" onClick={onCopy} testid="share-copy" />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function Action({ icon: Icon, label, onClick, testid }) {
  return (
    <button data-testid={testid} onClick={onClick} className="flex flex-col items-center justify-center gap-2 py-5 bg-[#0E0E0E] hover:bg-[#161616] transition-colors">
      <Icon size={22} weight="fill" className="text-[#FF1E1E]" />
      <span className="text-[10px] font-display tracking-widest uppercase text-white/75">{label}</span>
    </button>
  );
}
